import {I18N} from 'utilities/i18n';
import {BrandHandle, DeliveryEstimates} from 'utilities/delivery-promise/types';
import {DeliveryAddress} from 'utilities/location';
import {DateDifference} from 'utilities/dates';
import {Theme} from 'utilities/color/types';

export interface InterpolationValues {
  [key: string]: string;
}

export enum HolidayOverridePeriod {
  Dec5toDec11,
  Dec12toDec25,
  NotInOverridePeriod,
}

export enum ScenarioCost {
  Free = 'free',
  Paid = 'paid',
  ConditionallyFree = 'conditionallyFree',
}

export enum ScenarioVariant {
  SameDay = 'sameDay',
  OneDay = '1day',
  TwoDay = '2day',
  ThreeOrMoreDays = '3orMoreDays',
  BeforeTheWeekend = 'arrivesBeforeWeekend',
}

export interface Scenario {
  title: string;
  locationPrefix: string;
  expiry: DateDifference | null;
  expiresAt: string | null;
  marketingMessage?: string;
  conditionallyFree: string;
  showLogo: boolean;
  holidayOverride: string;
  logoSrc: string;
  logoAltText: string;
  brandHandle?: BrandHandle;
  sdkURL?: string;
  destinationAddress?: DeliveryAddress;
  hidePromise?: boolean;
  noPromiseReason?: string;
  destinationLineHasPrefix?: boolean;
  arrivesBeforeWeekendExtraLineMessage?: string;
  fasterOptionsAvailableExtraLineMessage?: string;
}

export interface PromiseProps {
  cost: ScenarioCost;
  variant: ScenarioVariant;
  maxDeliveryDate: Date | null;
  daysToDelivery: number;
  hasFasterOptions?: boolean;
  timezone?: string;
}

export interface PipelineProps {
  i18n: I18N;
  promiseProps: PromiseProps;
  deliveryEstimates: DeliveryEstimates | null;
  theme: Theme;
}
